import { render } from "./LogEntries.vue?vue&type=template&id=081e85b3"
import script from "./LogEntries.vue?vue&type=script&lang=js"
export * from "./LogEntries.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__